import { generateTableSlice } from "./sliceTable";

const sliceInsuranceTable = generateTableSlice("insuranceInReportingTab");

export const ActionsInsuranceTableInReportingTab = sliceInsuranceTable.actions;
export const ReducerInsuranceTableInReportingTab = sliceInsuranceTable.reducer;
